import type { Theme, ThemeProp } from 'types/theme';

export const sxImportant =
  (callback: ThemeProp<string | number>) => (theme: Theme) => {
    const value = typeof callback === 'function' ? callback(theme) : callback;
    return `${value} !important`;
  };
